import { Icon } from "@/components/icons";
import { trustBadges } from "@/data/site";

export default function TrustBar() {
  return (
    <section className="bg-white border-y border-charcoal/10" data-testid="trust-bar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
        <ul className="flex flex-wrap items-center justify-center gap-x-7 gap-y-2.5">
          {trustBadges.map((badge) => (
            <li key={badge.label} className="flex items-center gap-2 text-charcoal/75">
              <Icon name={badge.icon} className="w-4 h-4 text-rust shrink-0" />
              <span className="text-sm font-medium">{badge.label}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
